import { useProfile } from 'context/Profile'
import { usePaginatedListItems } from 'components/Commons/PaginatedList'

export function useGetNumberOfResults() {
  const { profile } = useProfile()
  const { language } = profile.userPreferences

  const { paging: { totalCount = 0 } = {} } = usePaginatedListItems()
  return totalCount?.toLocaleString(language) || 0
}
